export default "__VITE_ASSET__CqN5obAr__"